/**
 * Matching type answers are a single letter picked from Column B of the item
 * (or the matching pair of a matching-type-image item).
 *
 * The answer input only ever renders letters, but the raw keystrokes it receives
 * used to be forwarded verbatim, so saved answers ended up with stray characters
 * such as "B.", ".G" or "A. ". Those extra characters made correctly matched rows
 * compare as incorrect in the answer checker (AnswerManual / AnswerPDF result
 * pages, student & teacher views, tracker) and in the score computed by the API.
 *
 * Matching answers are therefore normalized to letters before they are stored,
 * displayed or compared. Non matching question types are left untouched because
 * options of multiple choice items are "0" / "1", which are not letters.
 */

const NON_LETTERS = /[^A-Za-z]/g;

export function isMatchingAnswerType(type = "") {
   return String(type).includes("matching");
}

export function normalizeMatchingAnswer(value) {
   if (value === null || value === undefined) return "";

   return String(value).replace(NON_LETTERS, "");
}

export function normalizeMatchingAnswers(values) {
   if (!Array.isArray(values)) return [];

   return values.map(normalizeMatchingAnswer);
}

export function matchingAnswersMatch(expected, actual) {
   return normalizeMatchingAnswer(expected).toLowerCase() === normalizeMatchingAnswer(actual).toLowerCase();
}

export function assessmentAnswersMatch(type, expected, actual) {
   if (isMatchingAnswerType(type)) {
      return matchingAnswersMatch(expected, actual);
   }

   return String(expected ?? "").toLowerCase() === String(actual ?? "").toLowerCase();
}
